"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureFlagsSetDataAction = exports.featureFlagsSetLoadingAction = exports.FEATURE_FLAGS_SET_DATA_ACTION = exports.FEATURE_FLAGS_SET_LOADING_ACTION = void 0;
var featureFlags_model_1 = require("../models/featureFlags.model");
/** ACTIONS */
exports.FEATURE_FLAGS_SET_LOADING_ACTION = 'FEATURE_FLAGS_SET_LOADING_ACTION';
exports.FEATURE_FLAGS_SET_DATA_ACTION = 'FEATURE_FLAGS_SET_DATA_ACTION';
/** ACTION CREATORS / THUNKS */
var featureFlagsSetLoadingAction = function (loadingFeatureFlags) { return function (dispatch) { return dispatch({
    type: exports.FEATURE_FLAGS_SET_LOADING_ACTION,
    payload: { loadingFeatureFlags: loadingFeatureFlags },
}); }; };
exports.featureFlagsSetLoadingAction = featureFlagsSetLoadingAction;
var featureFlagsSetDataAction = function (featureFlags) { return function (dispatch) { return dispatch({
    type: exports.FEATURE_FLAGS_SET_DATA_ACTION,
    payload: { featureFlags: featureFlags },
}); }; };
exports.featureFlagsSetDataAction = featureFlagsSetDataAction;
/** REDUCER */
var featureFlagsReducer = function (
// eslint-disable-next-line default-param-last
state, action) {
    if (state === void 0) { state = (0, featureFlags_model_1.featureFlagsStateFactory)(); }
    switch (action.type) {
        case exports.FEATURE_FLAGS_SET_LOADING_ACTION: return __assign(__assign({}, state), { loadingFeatureFlags: action.payload.loadingFeatureFlags });
        case exports.FEATURE_FLAGS_SET_DATA_ACTION: return __assign(__assign({}, state), { featureFlags: action.payload.featureFlags });
        default: return state;
    }
};
exports.default = featureFlagsReducer;
